<template>
  <v-container fluid class="mt-5 flex">
    <v-tabs
      v-model="tab"
      grow
      class="mb-5"
    >
    <v-tabs-slider></v-tabs-slider>
      <v-tab
        v-for="(tab, tabindex) in tabdata"
        :key="tabindex"
        :href="tab.href"
      >
        {{tab.label}}
      </v-tab>
      <v-tabs-items v-model="tab">
        <v-tab-item
          value="tab-1"
        >
          <v-row>
            <v-col
              cols="4"
            >
              <v-card>
                <v-card-title style="fontSize: 14px;">
                  <v-icon class="mr-3">mdi-chat</v-icon>Chats
                </v-card-title>
                <v-card-subtitle>
                  <v-text-field
                    filled
                    dense
                    prepend-inner-icon="mdi-magnify"
                    placeholder="search here..."
                    v-model="search"
                  ></v-text-field>
                </v-card-subtitle>
                <v-card-text>
                  <v-list dense>
                    <v-list-item-group
                      color="primary"
                    >
                      <v-list-item
                        v-for="(item, i) in get_conversation"
                        :key="i"
                        @click="get_messages(item)"
                      >
                        <v-list-item-icon>
                          <v-icon>mdi-comment-account</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-icon small class="mr-1" v-if="item.is_read == 0">mdi-message-badge</v-icon>
                            <label>
                              <strong v-if="item.is_read == 0">
                                {{item.supplier.name}}
                              </strong>
                              <label v-else>
                                {{item.supplier.name}}
                              </label>
                            </label> |
                            <label>
                              <strong v-if="item.is_read == 0">
                                {{item.request.project_name}}
                                <small 
                                  style="display: block;"
                                  v-if="item.request.deleted_at != null"
                                >
                                  <v-icon 
                                    class="mr-1"
                                    small
                                  >
                                    mdi-alert-box
                                  </v-icon>
                                  project deleted
                                </small>
                              </strong>
                              <label v-else>
                                {{item.request.project_name}}
                                <small 
                                  style="display: block;"
                                  v-if="item.request.deleted_at != null"
                                >
                                  <v-icon
                                    class="mr-1"
                                    small
                                  >
                                    mdi-alert-box
                                  </v-icon>
                                  project deleted
                                </small>
                              </label>
                            </label>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col
              v-if="Object.keys(get_convo).length != 0"
              cols="8"
              style="height: 560px; overflow: scroll;"
            >
              <v-row
                no-gutters
              >
                <v-container
                  v-for="(item_chat, item_chat_index) in get_convo"
                  :key="item_chat_index"
                >
                  <v-card
                    v-if="item_chat.from_client === 1"
                    color="blue darken-4"
                    style="float: right;"
                    class="rounded-tl-0"
                  >
                    <v-card-text>
                      <small class="white--text">you</small>
                      <h4 class="white--text" style="display:block;">{{item_chat.message}}</h4>
                      <small class="white--text" style="display:block;">{{item_chat.created_at}}</small>
                    </v-card-text>
                  </v-card>
                  <v-card
                    v-if="item_chat.from_supplier === 1"
                    color="blue darken-2"
                    style="float: left;"
                    class="rounded-tr-0"
                  >
                    <v-card-text>
                      <small class="white--text">supplier</small>
                      <h4 class="white--text">{{item_chat.message}}</h4>
                      <small class="white--text">{{item_chat.created_at}}</small>
                    </v-card-text>
                  </v-card>
                </v-container>
                <v-container>
                  <v-row
                    class="pa-2"
                  >
                    <v-text-field
                      rounded
                      v-model="message"
                      placeholder="Reply Here..."
                      outlined
                      append-icon="send"
                      @click:append="toggleSend"
                      @keypress.enter="toggleSend"
                    ></v-text-field>
                  </v-row>
                </v-container>
              </v-row>
            </v-col>
        </v-row>
        </v-tab-item>
        <v-tab-item
          value="tab-2"
        >
          <v-row>
            <v-col
              cols="4"
            >
              <v-card>
                <v-card-title style="fontSize: 14px;">
                  <v-icon class="mr-3">mdi-chat</v-icon>Chats
                </v-card-title>
                <v-card-subtitle>
                  <v-text-field
                    filled
                    dense
                    prepend-inner-icon="mdi-magnify"
                    placeholder="search here..."
                    v-model="search_supplier_directory"
                  ></v-text-field>
                </v-card-subtitle>
                <v-card-text>
                  <v-list dense>
                    <v-list-item-group
                      color="primary"
                    >
                      <v-list-item
                        v-for="(item, i) in get_conversation_supplier_directory"
                        :key="i"
                        @click="get_messages_supplier_directory(item)"
                      >
                        <v-list-item-icon>
                          <v-icon>mdi-comment-account</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-icon small class="mr-1" v-if="item.is_read == 0">mdi-message-badge</v-icon>
                            <label
                              v-if="item.supplier != null"
                            >
                              <strong v-if="item.is_read == 0">
                                {{item.supplier.name}}
                              </strong>
                              <label v-else>
                                {{item.supplier.name}}
                              </label>
                            </label>
                            <label
                              v-else
                            >No Name</label>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col
              v-if="Object.keys(get_convo_supplier_directory).length != 0"
              cols="8"
              style="height: 560px; overflow: scroll;"
            >
              <v-row
                no-gutters
              >
                <v-container
                  v-for="(item_chat, item_chat_index) in get_convo_supplier_directory"
                  :key="item_chat_index"
                >
                  <v-card
                    v-if="item_chat.from_client === 1"
                    color="blue darken-4"
                    style="float: right;"
                    class="rounded-tl-0"
                  >
                    <v-card-text>
                      <small class="white--text">you</small>
                      <h4 class="white--text" style="display:block;">{{item_chat.message}}</h4>
                      <small class="white--text" style="display:block;">{{item_chat.created_at}}</small>
                    </v-card-text>
                  </v-card>
                  <v-card
                    v-if="item_chat.from_supplier === 1"
                    color="blue darken-2"
                    style="float: left;"
                    class="rounded-tr-0"
                  >
                    <v-card-text>
                      <small class="white--text">supplier</small>
                      <h4 class="white--text">{{item_chat.message}}</h4>
                      <small class="white--text">{{item_chat.created_at}}</small>
                    </v-card-text>
                  </v-card>
                </v-container>
                <v-container>
                  <v-row
                    class="pa-2"
                  >
                    <v-text-field
                      rounded
                      v-model="message_supplier_directory"
                      placeholder="Reply Here..."
                      outlined
                      append-icon="send"
                      @click:append="toggleSendSupplierDirectory"
                      @keypress.enter="toggleSendSupplierDirectory"
                    ></v-text-field>
                  </v-row>
                </v-container>
              </v-row>
            </v-col>
        </v-row>
        </v-tab-item>
        <v-tab-item
          value="tab-3"
        >
          <v-row>
            <v-col
              cols="4"
            >
              <v-card>
                <v-card-title style="fontSize: 14px;">
                  <v-icon class="mr-3">mdi-chat</v-icon>Chats Upload Plan
                </v-card-title>    
                <v-card-subtitle>
                  <v-text-field
                    filled
                    dense
                    prepend-inner-icon="mdi-magnify"
                    placeholder="search here..."
                    v-model="upload_search"
                  ></v-text-field>
                </v-card-subtitle>
                <v-card-text>
                  <v-list dense>
                    <v-list-item-group
                      color="primary"
                    >
                      <v-list-item
                        v-for="(item, i) in get_convo_upload_plan"
                        :key="i"
                        @click="get_messages_upload_plan(item)"
                      >
                        <v-list-item-icon>
                          <v-icon>mdi-comment-account</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-icon small class="mr-1" v-if="item.is_read == 0">mdi-message-badge</v-icon>
                            <label>
                              <strong v-if="item.is_read == 0">
                                {{item.get_supplier.name}}
                              </strong>
                              <label v-else>
                                {{item.get_supplier.name}}
                              </label>
                            </label> |
                            <label>
                              <strong v-if="item.is_read == 0">
                                {{item.get_plan.name}}
                                <small 
                                  style="display: block;"
                                  v-if="item.get_plan.deleted_at != null"
                                >
                                  <v-icon 
                                    class="mr-1"
                                    small
                                  >
                                    mdi-alert-box
                                  </v-icon>
                                  project deleted
                                </small>
                              </strong>
                              <label v-else>
                                {{item.get_plan.name}}
                                <small 
                                  style="display: block;"
                                  v-if="item.get_plan.deleted_at != null"
                                >
                                  <v-icon
                                    class="mr-1"
                                    small
                                  >
                                    mdi-alert-box
                                  </v-icon>
                                  project deleted
                                </small>
                              </label>
                            </label>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col
              cols="8"
            >
              <v-row
                no-gutters
              >
                <v-container
                  v-for="(item_chat, item_chat_index) in get_conversation_upload_plan"
                  :key="item_chat_index"
                >
                  <v-card
                    v-if="item_chat.is_client === 1"
                    color="blue darken-4"
                    style="float: right;"
                    class="rounded-tl-0"
                  >
                    <v-card-text>
                      <small class="white--text">you</small>
                      <h4 class="white--text" style="display:block;">{{item_chat.client_message}}</h4>
                      <small class="white--text" style="display:block;">{{item_chat.created_at}}</small>
                    </v-card-text>
                  </v-card>
                  <v-card
                    v-if="item_chat.is_supplier === 1"
                    color="blue darken-2"
                    style="float: left;"
                    class="rounded-tr-0"
                  >
                    <v-card-text>
                      <small class="white--text">supplier</small>
                      <h4 class="white--text">{{item_chat.supplier_message}}</h4>
                      <small class="white--text">{{item_chat.created_at}}</small>
                    </v-card-text>
                  </v-card>
                </v-container>
                <v-container>
                  <v-row
                    class="pa-2"
                  >
                    <v-text-field
                      rounded
                      v-model="message_upload"
                      placeholder="Reply Here..."
                      outlined
                      append-icon="send"
                      @click:append="send_upload_plan_message"
                      @keypress.enter="send_upload_plan_message"
                    ></v-text-field>
                  </v-row>
                </v-container>
              </v-row>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item
          value="tab-4"
        >
          <ServiceSupplier/>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import ServiceSupplier from './modules/ServiceSupplier.vue'
export default {
  components: {
    ServiceSupplier
  },
  props: [
  ],
  data: () => ({
    selectedItem: null,
    items: [
      { text: 'Real-Time', icon: 'mdi-clock' },
      { text: 'Audience', icon: 'mdi-account' },
      { text: 'Conversions', icon: 'mdi-flag' },
    ],
    message: null,
    message_supplier_directory: null,
    search: null,
    search_supplier_directory: null,
    tab: null,
    tabdata: [
      {
        label:        'Supplier Request',
        href:         '#tab-1'
      },
      {
        label:        'Supplier Directory',
        href:         '#tab-2'
      },
      {
        label:        'Plan Upload',
        href:         '#tab-3'
      },
      {
        label:        'Service / Supplier',
        href:         '#tab-4'
      }
    ],
    upload_search: null,
    message_upload: null
  }),
  async mounted () {
    this.getmessages()
    this.get_supplier_directory()
    await this.$axios.get('inbox_uploadd_plan/g_chat_upload_plans')
    .then(({data}) => {
      if(data.response){
        this.$store.dispatch('inbox/set_convo_upload_plan', data.data)
      }else{
        this.showSnackBar('Error in retrievning conversation')
      }
    })
  },
  created () {
  },
  computed: {
    ...mapGetters({
      // get_conversation:           'inbox/get_conversation',
      get_convo:                            'inbox/get_convo',
      get_parent_convo:                     'inbox/get_parent_convo',
      get_convo_supplier_directory:         'inbox/get_convo_supplier_directory',
      get_parent_convo_supplier_directory:  'inbox/get_parent_convo_supplier_directory',
      get_conversation_upload_plan:         'inbox/get_conversation_upload_plan'
    }),
    get_conversation(){
      return this.$store.getters['inbox/get_conversation'](this.search)
    },
    get_conversation_supplier_directory(){
      return this.$store.getters['inbox/get_conversation_supplier_directory'](this.search)
    },
    get_convo_upload_plan(){
      return this.$store.getters['inbox/get_convo_upload_plan'](this.upload_search)
    }
  },
  methods: {
    showSnackBar(message){
      this.$store.commit("auth/setMessage", 
      {show: true, message: message}, 
      {root: 1})
    },
    async getmessages(){
      await this.$axios.get('/inbox/getChats')
      .then(({data}) => {
        this.$store.dispatch('inbox/set_conversation', data.data)
      })
    },
    async get_supplier_directory(){
      await this.$axios.get('/inbox/getChatsSupplierDirectory')
      .then(({data}) => {
        this.$store.dispatch('inbox/set_conversation_supplier_directory', data.data)
      })
    },
    async get_messages(data){
      await this.$axios.patch('/inbox/markread', data)
      this.$store.dispatch('inbox/set_parent_convo', data)
      this.$store.dispatch('inbox/set_convo', data.get_convo)
    },
    async get_messages_supplier_directory(data){
      await this.$axios.patch('/inbox/markreadsupplierdirectory', data)
      this.$store.dispatch('inbox/set_parent_convo_supplier_directory', data)
      this.$store.dispatch('inbox/set_convo_supplier_directory', data.get_convo)
    },
    async toggleSend(){
      // console.log(this.get_convo[0], this.message)
      await this.$axios.post('/inbox/sendMessageChat', {chat_id: this.get_convo[0], message: this.message, parent_convo: this.get_parent_convo})
      .then(({data}) => {
        if(data.response){
          this.showSnackBar(data.message)
          this.message = null
          this.getmessages()
          this.$store.dispatch('inbox/set_convo', data.data)
          return
        }else{
          this.showSnackBar(data.message)
          return
        }
      })
    },
    async toggleSendSupplierDirectory(){
      // console.log(this.get_convo[0], this.message)
      await this.$axios.post('/inbox/sendMessageChatSupplierDirectory', {supplier_directory_id: this.get_convo_supplier_directory[0], message: this.message_supplier_directory, parent_convo: this.get_parent_convo_supplier_directory})
      .then(({data}) => {
        if(data.response){
          this.showSnackBar(data.message)
          this.message_supplier_directory = null
          this.get_supplier_directory()
          this.$store.dispatch('inbox/set_convo_supplier_directory', data.data)
          return
        }else{
          this.showSnackBar(data.message)
          return
        }
      })
    },
    async get_messages_upload_plan(data){
      await this.$axios.get(`/inbox_uploadd_plan/g_convo/${data.plan_id}/${data.supplier_id}`)
      .then(({data}) => {
        this.$store.dispatch('inbox/set_conversation_upload_plan', data.data)
      })
    },
    async send_upload_plan_message(){
      this.showSnackBar('Please wait..')
      await this.$axios.post(
        `/inbox_uploadd_plan/s_message/${this.get_conversation_upload_plan[0].plan_id}/${this.get_conversation_upload_plan[0].supplier_id}`,
        {
          message: this.message_upload
        }
      )
      .then(({data}) => {
        if(data.response){
          this.showSnackBar(data.message)
          const datatopass = {
            plan_id: this.get_conversation_upload_plan[0].plan_id,
            supplier_id: this.get_conversation_upload_plan[0].supplier_id
          }
          this.get_messages_upload_plan(datatopass)
          this.message_upload = null
        }
      })
    }
  },
  watch: {
  }
}
</script>

<style scoped lang="scss">
</style>